<template>
  <div class="customize flex-grow-1 d-flex flex-column justify-content-between align-items-center">

    <div v-if="!thankyou">
      <div class="options w-100 mt-2">
        <p>Customize your card:</p>
      </div>
  
      <div class="d-flex w-100 my-3 overflow-auto">
        <div class="customize-canvas h-100 canvas-selection flex-shrink-0">
          <img crossOrigin="anonymous" :src="qrImg" class="addon d-none">
  
          <croppa
            v-model="myCroppa"
            :placeholder="'Select a background'"
            :placeholder-font-size="24"
            :initial-image="predefinedImg"
            :width="canvasWidth"
            :height="canvasHeight"
            :class="orientation"
            :canvas-color="canvasColor"
            :quality="3"
            :disable-drag-to-move="true"
            :disable-scroll-to-zoom="true"
            :prevent-white-space="true"
            :show-remove-button="false"
            :disable-click-to-choose="true"
            @draw="onDraw"
            class="mt-2">
          </croppa>
        </div>
  
        <div class="customize-swatches overflow-auto bg-selection">
          <div class="scrolling">
            <img src="/assets/bg-01.jpg" @click="selectImg('/assets/bg-01.jpg', 'bg-01')" class="w-100"/>
            <img src="/assets/bg-02.jpg" @click="selectImg('/assets/bg-02.jpg', 'bg-02')" class="w-100"/>
            <img src="/assets/bg-03.jpg" @click="selectImg('/assets/bg-03.jpg', 'bg-03')" class="w-100"/>
            <img src="/assets/bg-04.jpg" @click="selectImg('/assets/bg-04.jpg', 'bg-04')" class="w-100"/>
            <img src="/assets/bg-05.jpg" @click="selectImg('/assets/bg-05.jpg', 'bg-05')" class="w-100"/>
            <img src="/assets/bg-06.jpg" @click="selectImg('/assets/bg-06.jpg', 'bg-06')" class="w-100"/>
            <img src="/assets/bg-07.jpg" @click="selectImg('/assets/bg-07.jpg', 'bg-07')" class="w-100"/>
            <!-- <img src="/assets/bg-08.jpg" @click="selectImg('/assets/bg-08.jpg', 'bg-08')" class="w-100"/>
            <img src="/assets/bg-09.jpg" @click="selectImg('/assets/bg-09.jpg', 'bg-09')" class="w-100"/>
            <img src="/assets/bg-10.jpg" @click="selectImg('/assets/bg-10.jpg', 'bg-10')" class="w-100"/>
            <img src="/assets/bg-11.jpg" @click="selectImg('/assets/bg-11.jpg', 'bg-11')" class="w-100"/>
            <img src="/assets/bg-12.jpg" @click="selectImg('/assets/bg-12.jpg', 'bg-12')" class="w-100"/>
            <img src="/assets/bg-13.jpg" @click="selectImg('/assets/bg-13.jpg', 'bg-13')" class="w-100"/>
            <img src="/assets/bg-14.jpg" @click="selectImg('/assets/bg-14.jpg', 'bg-14')" class="w-100"/>
            <img src="/assets/bg-15.jpg" @click="selectImg('/assets/bg-15.jpg', 'bg-15')" class="w-100"/> -->
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Choose Card Theme</label>
        <div class="custom-control custom-switch">
          <input type="checkbox" v-model="themeCheckbox" class="custom-control-input" id="theme" @change="toggleTheme">
          <label class="custom-control-label" for="theme">{{theme.toUpperCase()}}</label>
        </div>
      </div>      
  
      <button type="button" class="btn btn-outline-success mb-4" @click="download('image/jpeg', 1)">
        <span v-if="!loading">
          <template v-if="type == 'update'">
            Update
          </template>
          <template v-else>
            Generate
          </template>
          My Card
        </span>
        <img v-else src="/assets/loader_white.gif" alt="loading">
      </button>
    </div>

    <div class="w-100" v-else>
      <div class="card-content d-flex flex-column justify-content-center align-items-center w-100 text-center px-4 mt-4">
        <h1 class="text-primary">Success! Card Created.</h1>
        <p>Your card has been successfully created.</p>
        <p>Please wait for <span v-html="countdown"></span> seconds while we redirect you to your <router-link :to="{ name: 'qr', params: { id: this.card.user_key }}" class="text-primary">Card Information</router-link> Page.</p>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import qs from 'querystring'
import Croppa from 'vue-croppa'
import 'vue-croppa/dist/vue-croppa.css'

const Header = () => import('../components/Header')

Vue.use(Croppa)

export default {
  data() {
    return {
      myCroppa: {},
      imgs: Array,
      predefinedImg: '',
      defaultImgCount: 4,
      orientation: 'portrait-canvas',
      canvasWidth: 420,
      canvasHeight: 740,
      canvasColor: 'transparent',
      qrImg: '',
      bgImg: '',
      loading: false,
      thankyou: false,
      countdown: 5,
      themeCheckbox: false,
      theme: 'dark'
    }
  },
  computed: {
    authToken: function() {
      return this.$store.state.authToken
    },
  },
  components: {
    Header
  },
  props: ['card', 'type'],
  methods: {
    toggleTheme: function() {
      this.theme = this.theme == 'dark' ? 'light' : 'dark'
      if(this.theme == 'light') {
        document.body.setAttribute("data-theme", "light")
      } else {
        document.body.setAttribute("data-theme", "dark")
      }
    },
    uploadCroppedImage: function() {
      this.myCroppa.generateBlob((blob) => {
      }, 'image/jpeg', 0.8)
    },
    chooseFile: function() {
      this.myCroppa.chooseFile();
    },
    onDraw: function(ctx) {
      ctx.save();
      ctx.globalAlpha = 1;
      let x, y;
      if(this.orientation == 'portrait-canvas') {
        x = 430;
        y = 880;
      } else {
        y = 520;
        x = 880;
      }
      ctx.drawImage(document.querySelector('.addon'), x, y, 400, 400)
      ctx.restore()
    },
    selectImg: function(url, bg) {
      this.predefinedImg = url;
      this.myCroppa.refresh();
      this.bgImg = bg+'.png';
    },
    setBgColor(color) {
      this.canvasColor = color;
    },
    thankyouCountdown: function() {
      this.thankyou = true
      let countdown = setInterval(() => {
        if(this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(countdown)
        this.$router.push({ name: 'qr', params: { id: this.card.user_key }});
        }
      }, 1000)
    },
    download: function(type, compressionRate) {
      if (!this.myCroppa.hasImage()) {
        alert('Please choose an image');
        return
      }
      this.loading = true;
      var data = { final_image: this.bgImg, theme_color: this.theme };
      axios
      .post(process.env.VUE_APP_API+'/card/send-email.php?user_key='+this.card.user_key,
        data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        auth: { 
          username: 'qintro-token',
          password: this.authToken
        }
      })
      .then((response) => {
        this.loading = false
        this.thankyouCountdown()
      })
      .catch(err => {
        if(err.response.status != 200) {
          this.$store.dispatch('expiredToken')
        } else {
          this.loading = false
        }
      })
    },
  },
  beforeMount() {
  },
  mounted () {
    this.$store.dispatch('checkSetAuthToken')
    const img = 'data:image/png;base64,'+this.card.qr
    this.qrImg = img
    this.themeCheckbox = (this.card.theme_color == 'dark' || this.card.theme_color ==  null) ? false : true
    this.theme = this.card.theme_color || 'dark'
  }
}
</script>

<style scoped>
.croppa-container,
.bg-selection img {
  border: 1px solid #fff;
}
.VueCarousel-dot-container {
  margin-top: 0!important;
  margin-bottom: 20px;
}
.bg-selection img {
  object-fit: cover;
  object-position: 50% 30%;

  width: 150px;
  height: 60px;
}
.scrolling {
  height: 0;
  min-height: 100%;
}
.customize-canvas {
  width: 75%;
}
.customize-swatches {
  width: 25%;
}
@media screen and (min-width: 768px)  {
  .customize-canvas {
    width: 50%;
  }
  .customize-swatches {
    width: 50%;
  }
  .customize-swatches .scrolling {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
  }
  .customize-swatches .scrolling img {
    width: 40%!important;
    margin: 10px;
  }
}

</style>
